/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
window.addEventListener('pageshow', function() {
	let overlay = document.querySelector('.PageTransition')
	if (overlay && overlay.style.opacity != 0) {
		overlay.style.opacity = 0
	}
})



/*============================================================================
  pdp find in store
==============================================================================*/

window.addEventListener('load', function() {

  MicroModal.init({
    openTrigger: "data-micromodal-trigger",
    closeTrigger: "data-micromodal-close",
    openClass: "is-open",
    disableScroll: true,
    disableFocus: false,
    awaitOpenAnimation: false,
    awaitCloseAnimation: false,
    debugMode: true,
  });


	function getReverseGeocodingData(lat, lng, input) {
		var latlng = new google.maps.LatLng(lat, lng)
		var geocoder = new google.maps.Geocoder()
		geocoder.geocode({ latLng: latlng }, (results, status) => {
			if (status !== google.maps.GeocoderStatus.OK) {
				alert(status)
			}
			if (status == google.maps.GeocoderStatus.OK) {
				input.value = results[0].address_components[4].long_name
				document.querySelector('.stockist-search-button button').click()
			}
		})
	}

	if (window.location.pathname.includes('/products/')) {
		const FindInStoreStockistObserver = new MutationObserver(function(
			mutations,
			mutationInstance
		) {
			const listResult = document.querySelector('.stockist-list-result')

			if (listResult) {
				// redefine structure as single list items can't achieve the required layout
				const directions = document.querySelectorAll('.stockist-result-directions-link')

				const distances = document.querySelectorAll('.stockist-result-distance')
				const map = document.querySelector('.stockist-map-google')
				const searchBar = document.querySelector('.stockist-query-entry')
				const searchInput = searchBar.querySelector('input')

				searchBar.insertAdjacentHTML(
					'afterend',
					'<button class="custom-search-button btn btn--full btn--dark"><span>Use my current location</span></button>'
				)

				const customSearchBtn = document.querySelector('.custom-search-button')

				customSearchBtn.addEventListener('click', function() {
					var options = {
						enableHighAccuracy: true,
						timeout: 5000,
						maximumAge: 0,
					}

					function success(pos) {
						var crd = pos.coords
						getReverseGeocodingData(crd.latitude, crd.longitude, searchInput)
					}

					function error(err) {
						console.warn(`ERROR(${err.code}): ${err.message}`)
					}

					navigator.geolocation.getCurrentPosition(success, error, options)
				})

				distances.forEach((distance) => {
					distance.remove()
				})

				map.remove()

				const allResults = document.querySelectorAll('.stockist-list-result')

				allResults.forEach((result) => {
					const currentMarkup = result.innerHTML
					const wrappedMarkup = `<div class='result-wrap'>${currentMarkup}</div>`
					result.innerHTML = `
          <div class='result-logo'></div>
          ${wrappedMarkup}
          <div class='result-quantity'>
            <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
          </div>`
				})

				mutationInstance.disconnect()
			}
		})

		FindInStoreStockistObserver.observe(document, {
			childList: true,
			subtree: true,
		})

		// find in store pdp button
		// calls ap21 endpoint and checks against the hidden custom field for store name
		const findInStoreSelector = document.getElementById('find-in-store')

		findInStoreSelector.addEventListener('click', function() {
			// const variantDomArr = document.querySelectorAll('.variant-input')
			// const variantArray = [...variantDomArr]
			// 	.map((variant, idx) => {
			// 		const input = variant.getElementsByTagName('INPUT')
			// 		const inputState = input[0].checked
			// 		if (inputState) {
			// 			return idx
			// 		}
			// 	})
			// 	.filter(function(element) {
			// 		return element !== undefined
			// 	})

			// const variantSkuObj = Object.values(window.inventories)
			// const variantSkuArray = Object.values(Object.assign({}, ...variantSkuObj))
			// const idx = variantArray[0]
			// const variantSku = variantSkuArray[idx].variantSku

			// fetch(
			// 	`https://${window.Shopify.shop}/apps/dotapparel21/api-checkStock?sku=${variantSku}`
			// )
			// 	.then((response) => response.json())
			// 	.then((data) => {
			// 		const ap21StoreArray = Object.values(data)
			// 		const ap21Stores = ap21StoreArray[0].map((store) => {
			// 			return {
			// 				name: store.attributes.storeName,
			// 				stock: store.attributes.freeStock,
			// 			}
			// 		})

			// 		const allResults = document.querySelectorAll('.stockist-list-result')

			// 		allResults.forEach((result) => {
			// 			const customField = result.querySelector('.stockist-result-custom-field')
			// 			const quantityField = result.querySelector('.result-quantity')

			// 			let customFieldTxt
			// 			if (customField) {
			// 				customFieldTxt = customField.childNodes[1].textContent
			// 				ap21Stores.forEach((store) => {
			// 					if (customFieldTxt.trim() === store.name.trim()) {
			// 						quantityField.innerHTML = `${store.stock} items available`
			// 					} else {
			// 						quantityField.innerHTML = `Please call store to confirm`
			// 					}
			// 				})
			// 			} else {
			// 				quantityField.innerHTML = `0 items available`
			// 			}
			// 		})
			// 	})
			// 	.catch((error) => {
			// 		console.warn(error)
			// 	})
		})
	}
})

// document.addEventListener('product:added', function(event) {
// 	console.log(event);
// 	console.log('Product added to cart');
// });